import { render } from "./LoupePlus.vue?vue&type=template&id=0b1d2328"
import script from "./LoupePlus.vue?vue&type=script&lang=js"
export * from "./LoupePlus.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__